export const EMBED_GOOGLE_DOC_CONFIG = {
    name        : 'Google Doc',
    icon        : 'i5-google-doc',
    iconSvg     : 'isvg-google-doc',
    description : 'Embeded Google Doc',
    embedCode   : '',
    projectIcon : 'googleDoc',                  // from ConstItemIcon and ProjectIconDictionary

    keyWords    : ['docs.google.com/document']  // required for embedCode content search for autodetect EmbedType
}
